import { render, staticRenderFns } from "./TukiosastonHenkilot.vue?vue&type=template&id=36e824f6"
import script from "./TukiosastonHenkilot.vue?vue&type=script&lang=js"
export * from "./TukiosastonHenkilot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports